// extracted by mini-css-extract-plugin
module.exports = {"Wrapper":"ButtonsWrapper__Wrapper_2dxkg","Button":"ButtonsWrapper__Button_1JbUl"};